var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "chevron-down",
  "use": "chevron-down-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"chevron-down\"><path d=\"M9 12.128 1.194 4.32.514 5 9 13.485 17.485 5l-.679-.679\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol